<script setup lang="ts">
/**
 * UI-kit component
 * Category: Buttons
 * Name: BtnLinkCopy
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=8144-123320&t=Q08xSIR99kih0t0I-4
 */
import type { BtnLinkCopyProps } from '../types/interfaces'

import { faFiles } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { AppTooltip } from '@shared/ui/tooltips'
import { IconContainer } from '@shared/ui/other'

import { useBtnLinkCopy } from '../composables/use-btn-link-copy.hook'

defineOptions({
  name: 'BtnLinkCopy',
})

const props = withDefaults(defineProps<BtnLinkCopyProps>(), {
  disabled: false,
  tooltipText: 'Copy link',
})

const {
  refIsSupported,
  refTooltipText,
  setCopy,
} = useBtnLinkCopy({ props })
</script>

<template>
  <div
    v-if="refIsSupported"
    class="btn-link-copy"
  >
    <AppTooltip
      v-if="refTooltipText"
      :text="refTooltipText"
    >
      <button
        type="button"
        class="btn-link-copy__btn"
        :disabled="disabled"
        @click="setCopy"
      >
        <IconContainer>
          <FontAwesomeIcon :icon="faFiles" />
        </IconContainer>
      </button>
    </AppTooltip>
    <button
      v-else
      type="button"
      class="btn-link-copy__btn"
      :disabled="disabled"
      @click="setCopy"
    >
      <IconContainer>
        <FontAwesomeIcon :icon="faFiles" />
      </IconContainer>
    </button>
  </div>
</template>

<style lang="scss" scoped src="../styles/_btn-link-copy.scss" />
